export const SKIP_TO_ELEMENT_ID = 'set-focus-here';
